var axios = require("axios");
var settings = require("../../settings.json");
var i18n = require("./i18n");
const swal = require("sweetalert2");
var { v4 } = require("uuid");
var { toast } = require("bulma-toast");
var currency = require("../../common/currency.json");
var moment = require("moment");

var resources_allowed_for_all = require("../../api/session/resources_allowed_for_all.json");

exports.api_host = settings.api_host;

exports.current_host = window.location.origin;

exports.register_listener = (name, func) => {
  window.jQuery(window).off(name);
  window.jQuery(window).on(name, func);
};

exports.confirm_deletion_dialog = (title, v, f, text) => {
  swal
    .fire({
      title: title,
      showDenyButton: true,
      icon: "question",
      // showCancelButton: true,
      text: text,
      confirmButtonText: v.$t("yes"),
      denyButtonText: v.$t("no"),
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap",
        confirmButton: "order-2",
        denyButton: "order-3",
      },
    })
    .then(function (result) {
      if (result.isConfirmed) {
        if (f && typeof f == "function") f();
      }
    });
};

exports.input_alert = (options) => {
  let title = options.title || "";
  let text = options.text || "";
  let input = options.input || "text";
  let input_label = options.input_label || "";
  let input_value = options.input_value || "";
  let show_cancel_button =
    options.show_cancel_button == undefined ? true : options.show_cancel_button;
  return new Promise((resolve /* reject */) => {
    swal
      .fire({
        title: title,
        text: text,
        input: input,
        inputLabel: input_label,
        inputValue: input_value,
        showCancelButton: show_cancel_button,
      })
      .then((result) => {
        if (result.isConfirmed) resolve(result.value);
      });
  });
};

exports.confirm_activation_dialog = (title, v, f) => {
  swal
    .fire({
      title: title,
      showDenyButton: true,
      icon: "question",
      // showCancelButton: true,
      confirmButtonText: v.$t("yes"),
      denyButtonText: v.$t("no"),
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap",
        confirmButton: "order-2",
        denyButton: "order-3",
      },
    })
    .then(function (result) {
      if (result.isConfirmed) {
        if (f && typeof f == "function") f();
      }
    });
};

var timeout = settings.timeout;
var language = settings.language;

var get_session_token = () => {
  return localStorage.getItem("session_token");
};

var get_user_data = () => {
  return JSON.parse(localStorage.getItem("user_data"));
};

exports.session_token = get_session_token;
exports.get_user_data = get_user_data;

exports.set_language = (vue_isntance, lang) => {
  language = lang;
  i18n.default.global.locale = lang;
};

var get_permissions = () => {
  let permissions = localStorage.getItem("permissions");
  return (
    JSON.parse(permissions) ||
    [{ path: "^/system/settings$", method: "GET" }].concat(
      resources_allowed_for_all
    )
  );
};

var have_permission = (resource, method) => {
  // console.log("checking permissions", resource, method);
  let permissions = get_permissions();
  let validate_permissions_in_frontend =
    settings.validate_permissions_in_frontend;

  // console.log("checking permissions", permissions);
  if (!validate_permissions_in_frontend) return true;

  return permissions.find((p) => {
    let path_without_args = p.path.replace(/\?.*$/g, "");
    if (path_without_args.endsWith("\\"))
      path_without_args = path_without_args.slice(0, -1);

    let mtch =
      resource.match(path_without_args) &&
      p.method.toLowerCase() == method.toLowerCase();

    return (
      (resource.match(p.path) &&
        p.method.toLowerCase() == method.toLowerCase()) ||
      (resource.match(p.path) && (p.is_api == true || p.is_public == true)) ||
      mtch
    );
  }) /* || true */;
};

exports.get_permissions = get_permissions;

exports.post = (resource, params = {}) => {
  let c = this;
  return consume_method("post", c.api_host, resource, timeout, params);
};

exports.put = (resource, params = {}) => {
  let c = this;
  return consume_method("put", c.api_host, resource, timeout, params);
};

exports.get = (resource, params = {}) => {
  let c = this;
  return consume_method("get", c.api_host, resource, timeout, params);
};

exports.get_file = (resource, params = {}) => {
  let c = this;
  return consume_method(
    "get",
    c.api_host,
    resource,
    timeout,
    params,
    true,
    "blob"
  );
};

exports.del = (resource, params = {}) => {
  let c = this;
  return consume_method("delete", c.api_host, resource, timeout, params);
};

var consume_method = (
  method,
  api_host,
  resource,
  timeout,
  params,
  resolve_whole_response = false,
  response_type = undefined
) => {
  return new Promise((resolve, reject) => {
    let _resource = `${api_host}${resource}`;

    let token = get_session_token();
    let user_data = get_user_data();
    let timout = params._timeout || timeout;
    delete params._timeout;
    if (have_permission(resource, method)) {
      let config = { timeout: timout, params: params };
      if (response_type) config.responseType = response_type;
      if (token) {
        config.headers = {
          "modul-access-token": token,
          language: language,
          enterprise: user_data.enterprise_name,
        };
      }
      if (!config.headers) config.headers = { language: language };

      if (["post", "put"].includes(method)) {
        delete config.params;
        axios[method](_resource, params, config)
          .then((r) => {
            if (resolve_whole_response) resolve(r);
            else resolve(r.data);
          })
          .catch((err) => {
            let er = process_error(err);
            reject(er);
            // console.error(er);
            // reject({
            //   code: err.code || "",
            //   message: err.message,
            //   response: err.response?.data ?? "",
            // });
          });
      } else if (["get", "delete"].includes(method)) {
        axios[method](_resource, config)
          .then((r) => {
            if (resolve_whole_response) resolve(r);
            else resolve(r.data);
          })
          .catch((err) => {
            let er = process_error(err);
            reject(er);
            // let er = process_error(err);
            // console.error(er);
            // reject({
            //   code: err.code || "",
            //   message: err.message,
            //   response: err.response?.data ?? "",
            // });
          });
      } else {
        reject({
          code: "405",
          message: "Método no permitido",
        });
      }
    } else {
      console.log(method, resource, params);
      reject({
        code: "403",
        message: "No tiene permisos para realizar esta acción",
      });
    }
  });
};

var process_error = (error) => {
  console.error(error);
  try {
    let { code, /* message, name, */ response } = error;
    if (code == "ERR_BAD_RESPONSE") {
      // const regex = /<body[^>]*>([\s\S]*?)<\/body>/i;
      // const found = response.data.match(regex);
      // console.log(found);
      // let r = found.reduce((prev, curr) => {
      //   return prev + curr.replace(/\n/g, "").replace(/&nbsp;/g, "");
      // }, "");

      // return {
      //   status: response.status,
      //   text: response.statusText,
      //   // data: found,
      //   data: response.data.replace(/\n/g, ""),
      // };

      if (response.status == 511) {
        localStorage.clear();
        let rr = `/login?redir=${window.location.pathname}${window.location.search}`;
        window.location = rr;
        return response.data.replace(/\n/g, "");
      } else {
        return {
          status: response.status,
          text: response.statusText,
          // data: found,
          data: response.data.replace(/\n/g, ""),
        };
      }
    } else if (code == "ERR_BAD_REQUEST") {
      return {
        status: response.status,
        text: response.statusText,
        data: response.data.replace(/\n/g, ""),
      };
    } else return error;
  } catch (err) {
    console.error(error);
    return error;
  }
};

// exports.error_toast = (options) => {
//   let title = options.title || "";
//   let message = options.message || "";

//   window.jQuery.toast({
//     position: "bottom attached",
//     class: "error",
//     title: title,
//     message: message,
//   });
// };

// exports.success_toast = (options) => {
//   let title = options.title || "";
//   let message = options.message || "";
//   console.log("title");
//   window.jQuery.toast({
//     position: "bottom attached",
//     class: "success",
//     title: title,
//     message: message,
//   });
// };

exports.save_configuration = (vueInstance, data) => {
  let v = this;
  return new Promise((resolve, reject) => {
    try {
      let code_name = vueInstance.$route.path
        .split("/")
        .filter((x) => x)
        .find((x) => x);

      v.put("/system/module/settings", { code_name, data })
        .then((x) => {
          resolve(x);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

exports.get_configuration = (vueInstance) => {
  let v = this;
  return new Promise((resolve, reject) => {
    try {
      let code_name = vueInstance.$route.path
        .split("/")
        .filter((x) => x)
        .find((x) => x);

      v.get("/system/module/settings", { code_name })
        .then((x) => {
          resolve(x);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

exports.user_data = () => {
  let user_data = localStorage.getItem("user_data");
  return JSON.parse(user_data);
};

exports.generate_datatables_buttons = (buttons = []) => {
  let _this = this;
  return `<p class="buttons">${buttons.reduce((prev, curr) => {
    let uuid = v4();
    if (curr.click && typeof curr.click == "function")
      _this.register_listener(uuid, curr.click);
    return (
      prev +
      `<a class="button is-small" data-tooltip="${curr.tooltip}"
    onclick="window.dispatchEvent(new CustomEvent('${uuid}', {'detail': { uuid: '${curr.args.uuid}'}}))">
        <span class="icon ${curr.icon_class}">
          <i class="${curr.icon}"></i>
        </span>
      </a>`
    );
  }, "")}</p>`;
};

exports.generate_datatables_button = (options) => {
  let uuid = options.args.uuid;
  let tooltip = options.tooltip;
  let icon = options.icon;
  let icon_class = options.icon_class;
  let click = options.click;
  let event_uuid = v4();
  if (click && typeof click == "function")
    this.register_listener(event_uuid, click);
  return `<a class="button is-small" data-uuid="${uuid}" data-tooltip="${tooltip}"
  onclick="window.dispatchEvent(new CustomEvent('${event_uuid}', {'detail': { uuid: '${uuid}'}}))">
      <span class="icon ${icon_class}">
        <i class="${icon}"></i>
      </span>
    </a>`;
};

// exports.success_alert = (options) => {
exports.success_message = (options) => {
  let title = "";
  if (typeof options == "string") title = options;
  else if (typeof options == "object")
    title = options.title || JSON.stringify(options);

  toast({
    message: title,
    type: "is-success",
    // dismissible: true,
    pauseOnHover: true,
    position: "top-center",
  });
};

exports.error_message = (error) => {
  // console.error(error);
  let message = "";
  if (typeof error == "string") message = error;
  else if (typeof error == "object") {
    if (error.responseText) {
      message = error.responseText.replace(/\n/g, "");
    } else {
      let lst = Object.keys(error).reduce((prev, curr) => {
        return prev + `<li>${curr} ${error[curr]}</li>`;
      }, "");
      message = `<ul>${lst}</ul>`;
    }
  } else message = JSON.stringify(error);

  toast({
    message: message,
    type: "is-danger",
    // dismissible: true,
    pauseOnHover: true,
    position: "top-center",
  });
};

exports.warning_message = (error) => {
  // console.error(error);
  let message = "";
  if (typeof error == "string") message = error;
  else if (typeof error == "object") {
    if (error.responseText) {
      message = error.responseText.replace(/\n/g, "");
    } else {
      let lst = Object.keys(error).reduce((prev, curr) => {
        return prev + `<li>${curr} ${error[curr]}</li>`;
      }, "");
      message = `<ul>${lst}</ul>`;
    }
  } else message = JSON.stringify(error);

  toast({
    message: message,
    type: "is-warning",
    // dismissible: true,
    pauseOnHover: true,
    position: "top-center",
  });
};

exports.generate_error_message_text = (error) => {
  let message = "";
  if (typeof error == "string") message = error;
  else if (typeof error == "object") {
    if (error.responseText) {
      message = error.responseText.replace(/\n/g, "");
    } else {
      let lst = Object.keys(error).reduce((prev, curr) => {
        return prev + `<li>${curr} ${error[curr]}</li>`;
      }, "");
      message = `<ul>${lst}</ul>`;
    }
  } else message = JSON.stringify(error);

  return message;
};

exports.change_active_tab = ($event, v) => {
  // let v = this;
  let target = $event.target;
  let active_tab = "";
  if (target) active_tab = window.jQuery(target).closest("li").data("tab");
  if (active_tab) {
    /** Headers */
    window.jQuery(v.$refs.tabs).find("li").removeClass("is-active");
    window
      .jQuery(v.$refs.tabs)
      .find(`li[data-tab=${active_tab}]`)
      .addClass("is-active");

    /** Content */
    window.jQuery(v.$refs.contents).find(">div").addClass("is-hidden");
    // .attr("display", "none");
    window
      .jQuery(v.$refs.contents)
      .find(`div[data-tab=${active_tab}]`)
      .removeClass("is-hidden");
  }
};

/** Formats */
exports.format_date = (date) => {
  let format = get_system_settings().enterprise_settings.date_format;
  let dte = moment(date);
  // console.log("date", date, dte, format);
  return dte.format(format);
};

exports.format_date_time = (date) => {
  let format = get_system_settings().enterprise_settings.date_time_format;
  return moment(date).format(format);
};

exports.format_time = (date) => {
  let format = get_system_settings().enterprise_settings.time_format;
  return moment(date).format(format);
};

exports.format_currency = (number) => {
  let currency_settings =
    get_system_settings().enterprise_settings.currency_settings;
  // console.log("currency_settings", currency_settings);

  let nmbr = Number(number).toFixed(currency_settings.decimal_digits);
  let formatted_number = new Intl.NumberFormat({
    style: "decimal",
    minimumFractionDigits: currency_settings.decimal_digits,
    maximumFractionDigits: currency_settings.decimal_digits,
  }).format(nmbr);

  // let nmbr = new Intl.NumberFormat().format(
  //   Number(number).toFixed(currency_settings.decimal_digits)
  // );
  return `${currency_settings.symbol} ${formatted_number}`;
};

exports.get_currency_settings = () => {
  let currency_settings =
    get_system_settings().enterprise_settings.currency_settings;
  return currency_settings;
};

var get_system_settings = () => {
  let ud = localStorage.getItem("user_data");
  // console.log("ud", ud);
  if (ud) {
    let user_data = JSON.parse(ud);

    let enterprise_settings = user_data.enterprise_settings || {};
    if (enterprise_settings.currency) {
      let currency_settings = currency[enterprise_settings.currency];
      enterprise_settings.currency_settings = currency_settings;
    }

    let user_settings = user_data.settings || {};
    if (user_settings.currency) {
      let currency_settings = currency[user_settings.currency];
      user_settings.currency_settings = currency_settings;
    }

    return { enterprise_settings, user_settings };
  } else
    return {
      enterprise_settings: {
        currency_settings: { decimal_digits: 2, symbol: "Q" },
        date_format: "DD/MM/YYYY",
      },
    };
};

exports.system_settings = get_system_settings();

exports.create_socket = () => {
  let token = this.session_token();
  let user_data = this.user_data();
  return new Promise((resolve, reject) => {
    let socket_string = `${settings.web_socket_host}?token=${token}&enterprise=${user_data.enterprise_name}`;
    // console.log(socket_string);
    let socket = new WebSocket(socket_string, "echo-protocol");
    socket.onopen = () => {
      // socket.send(
      //   JSON.stringify({
      //     method: "auth",
      //     token: token,
      //     enterprise: user_data.enterprise_name,
      //   })
      // );

      resolve(socket);
    };

    socket.onclose = function () {
      // console.log("socket connection closed");
    };

    socket.onerror = (err) => {
      console.error(err);
      reject(err);
    };
  });
};
exports.download = (resource, file_name) => {
  return new Promise((resolve, reject) => {
    this.get_file(resource, { _timeout: 60000 * 3 })
      .then((response) => {
        // console.log(response.data)
        // window.open(URL.createObjectURL(response.data));

        // console.log("response");
        // console.log(response.headers.get("content-type"));
        // console.log(response);

        // var blob = new Blob([response.body], {
        //   type: response.headers.get("content-type"),
        // });

        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(response.data);
        link.download = file_name;
        link.click();
        resolve();
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

exports.translate_file_size = (size) => {
  var i = -1;
  var byteUnits = [" kb", " mb", " gb", " tb"];
  do {
    size /= 1024;
    i++;
  } while (size > 1024);

  return Math.max(size, 0.1).toFixed(1) + byteUnits[i];
};

exports.base64_to_pdf = (base64, file_name) => {
  var linkSource = `data:application/pdf;base64,${base64}`;
  var downloadLink = document.createElement("a");
  var fileName = file_name;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

exports.drive_static_file_url = (file_name) => {
  return `${settings.api_host}/drive/static/${file_name}`;
};
